<template>
  <card-prime id="card-prime">
    <template #content>
      <div id="finalizar-cadastro">
        <TituloComponent
          classTitulo="text-blue-800 text-2xl font-bold mb-6"
          titulo="Informações adicionais"
          :exiberLinha="false"
        />
        <div class="formgrid grid">
          <div class="field col-12">
            <label for="aluno-nome">Como deseja receber nosso contato</label>
          </div>
          <div class="flex field col-12 md:col-3">
            <div class="flex flex-row flex-wrap">
              <InputSwitch
                id="aluno-tipo-endereco"
                v-model="Interesse.ContatoEmail"
              />
            </div>
            <div class="flex flex-wrap align-items-center card-container pl-3">
              <span class="text-left vertical-align-text-bottom">E-mail</span>
            </div>
          </div>
          <div class="flex field col-12 md:col-3">
            <div class="flex flex-row flex-wrap">
              <InputSwitch
                id="aluno-tipo-endereco"
                v-model="Interesse.ContatoTelefone"
              />
            </div>
            <div class="flex flex-wrap align-items-center card-container pl-3">
              <span class="text-left vertical-align-text-bottom">Telefone</span>
            </div>
          </div>
        </div>
        <div class="formgrid grid">
          <div class="field col-12 md:col-12">
            <label for="aluno-observacoes">Observações</label>
            <TextArea
              id="aluno-observacoes"
              v-model="Interesse.Observacoes"
              :autoResize="true"
              rows="5"
              maxlength="2000"
              placeholder="Aqui você pode adicionar informações complementares ou enviar suas dúvidas."
            />
            <label class="text-sm flex justify-content-end flex-wrap"
              >Máximo de 2.000 caracteres</label
            >
          </div>
        </div>
      </div>
    </template>
  </card-prime>
</template>

<script>
import { useInteresseStore } from "@/store/interesse";
import { storeToRefs } from "pinia";
import TituloComponent from "@/components/comuns/TituloComponent.vue";
import CardPrime from "primevue/card";

export default {
  name: "InformacoesAdicionaisComponent",

  setup() {
    const storeInteresse = useInteresseStore();
    const { Interesse } = storeToRefs(storeInteresse);
    return { Interesse };
  },

  components: {
    TituloComponent,
    CardPrime,
  },
};
</script>